"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/formFill/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _links = require('shared/services/forms/links');

var _store = require('web/store');
var _app = require('web/services/app');
var _Spinner = require('web/components/Spinner');
var _PatientPage = require('web/patientResponse/PatientPage');

var _MonthLog = require('./MonthLog'); var _MonthLog2 = _interopRequireDefault(_MonthLog);
var _PageView = require('./PageView'); var _PageView2 = _interopRequireDefault(_PageView);
var _Signer = require('./Signer'); var _Signer2 = _interopRequireDefault(_Signer);

require('./formFill.scss');

/* The family's form link (blm.care/F{code}): fill and sign a form, or keep a
 * monthly log. Link scanners open it, so loading only reads: GetFamilyForm.
 * AddFormRow and SubmitForm run only on a click after typed input, and
 * nothing is marked seen. */

// The form page never offers the app.
const NO_PROMPT = { storeUrl: null, dismiss: () => undefined, showsManualLink: false, bannerAbove: false }
const RECONNECT_MS = 2000



const CheckIcon = () => (
  _react2.default.createElement('svg', { viewBox: "0 0 24 24"   , width: "28", height: "28", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
    , _react2.default.createElement('path', { d: "M5 12.5l4.5 4.5L19 7.5"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}} )
  )
)
const ClockIcon = () => (
  _react2.default.createElement('svg', { viewBox: "0 0 24 24"   , width: "28", height: "28", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
    , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "8.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
    , _react2.default.createElement('path', { d: "M12 7.5V12l3 2"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )
  )
)
const WarningIcon = () => (
  _react2.default.createElement('svg', { viewBox: "0 0 24 24"   , width: "28", height: "28", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
    , _react2.default.createElement('path', { d: "M12 4 2.8 19.5h18.4z"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} )
    , _react2.default.createElement('path', { d: "M12 10v4.5M12 17.2h.01"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
  )
)








const StateScreen = ({ tone, icon, title, children }) => (
  _react2.default.createElement('div', { className: "form-fill--state", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
    , _react2.default.createElement('div', { className: `form-fill--state-icon form-fill--state-icon-${tone}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}},  icon )
    , _react2.default.createElement('h1', { className: "form-fill--state-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}},  title )
    , _react2.default.createElement('div', { className: "form-fill--state-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}},  children )
  )
)

const FormFill = () => {
  const [load, setLoad] = _react.useState('loading')
  const [view, setView] = _react.useState(null)
  const [viewingPage, setViewingPage] = _react.useState.call(void 0, false)
  const loadRef = _react.useRef.call(void 0, load)
  loadRef.current = load

  _react.useEffect.call(void 0, () => {
    const code = _optionalChain([_app.FORM_FILL_PATH, 'access', _ => _.exec, 'call', _2 => _2(_store.history.location.pathname), 'optionalAccess', _3 => _3[1]])
    if (!code) {
      setLoad('invalid')
      return undefined
    }
    let reconnectTimer
    // The client's own retry reconnects without the code, so a reconnect
    // opens it again with it. A form link's socket takes only the form's
    // commands, so it sends no activity pings (open turns them back on).
    const open = () => {
      _client2.default.open({ auth: { Type: 'form_code', Code: code } })
      _client2.default.stopPinging()
    }

    const onAuthenticated = () => {
      _client2.default.send('GetFamilyForm', {})
        .then(({ Form }) => {
          setView(Form)
          setLoad(l => (l === 'sent' ? l : 'ready'))
        })
        .catch((err) => {
          setLoad(l => (l === 'ready' || l === 'sent' ? l : _optionalChain([err, 'optionalAccess', _4 => _4.Error]) === 'This form link is invalid.' ? 'invalid' : 'failed'))
        })
    }
    const onAuthError = ({ Error }) => setLoad(Error === 'Invalid Code' ? 'invalid' : 'failed')
    const onClosed = () => {
      if (loadRef.current === 'invalid' || loadRef.current === 'sent') return
      clearTimeout(reconnectTimer)
      reconnectTimer = setTimeout(open, RECONNECT_MS)
    }

    _client2.default.on('authentication-success', onAuthenticated)
    _client2.default.on('authentication-error', onAuthError)
    _client2.default.on('unexpected-closed', onClosed)
    open()
    // Another link opened in this tab (only the hash changes): load it afresh.
    const stopListening = _store.history.listen(location => {
      if (_optionalChain([_app.FORM_FILL_PATH, 'access', _5 => _5.exec, 'call', _6 => _6(location.pathname), 'optionalAccess', _7 => _7[1]]) !== code) window.location.reload()
    })
    return () => {
      stopListening()
      clearTimeout(reconnectTimer)
      _client2.default.off('authentication-success', onAuthenticated)
      _client2.default.off('authentication-error', onAuthError)
      _client2.default.off('unexpected-closed', onClosed)
    }
  }, [])

  const onRowAdded = _react.useCallback.call(void 0, (row) => {
    setView(v => v && { ...v, Rows: [...(_nullishCoalesce(v.Rows, () => ( []))), row] })
  }, [])
  const onSigned = _react.useCallback.call(void 0, () => setLoad('sent'), [])
  const viewPage = _react.useCallback.call(void 0, () => setViewingPage(true), [])
  const closePage = _react.useCallback.call(void 0, () => setViewingPage(false), [])

  const team = _optionalChain([view, 'optionalAccess', _8 => _8.TeamName]) || 'your provider'
  const caption = _optionalChain([view, 'optionalAccess', _9 => _9.TeamName]) ? (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('span', { className: "patient-page--caption-from", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}, "From:")
      ,  ' ' 
      , _react2.default.createElement('span', { className: "patient-page--caption-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}},  view.TeamName )
    )
  ) : ' '

  let body
  if (load === 'loading') {
    body = _react2.default.createElement('div', { className: "form-fill--state", __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}, _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 136}} ))
  } else if (load === 'invalid') {
    body = (
      _react2.default.createElement(StateScreen, { tone: "bad", icon: _react2.default.createElement(WarningIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 139}} ), title: "This form link is invalid"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}, "Please ask your provider for a new link."

      )
    )
  } else if (load === 'failed' || !view) {
    body = (
      _react2.default.createElement(StateScreen, { tone: "bad", icon: _react2.default.createElement(WarningIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 145}} ), title: "This form didn't load"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}, "Please reload the page, or ask your provider for a new link."

      )
    )
  } else if (load === 'sent') {
    body = (
      _react2.default.createElement(StateScreen, { tone: "ok", icon: _react2.default.createElement(CheckIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 151}} ), title: `Sent to ${team}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}
          ,  view.FormName , " is signed."
          ,  view.Secure && ` A copy of the signed form is in your chat with ${team}.` 
        )
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}, "You can close this page."    )
      )
    )
  } else if (view.State === 'signed') {
    const at = _links.isSetTime.call(void 0, view.SubmittedAt) ? _moment2.default.call(void 0, view.SubmittedAt) : null
    body = (
      _react2.default.createElement(StateScreen, { tone: "ok", icon: _react2.default.createElement(CheckIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 162}} ), title: "Already signed" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}, "You signed "
          ,  view.FormName ,  at && ` on ${at.format('MMM D')} at ${at.format('h:mm A')}` , "."
        ,  view.Secure && ` The signed copy is in your chat with ${team}.` 
      )
    )
  } else if (view.State === 'expired') {
    // ExpiresAt is the first moment after the last open day (UTC).
    const until = _moment2.default.utc(view.ExpiresAt).subtract(1, 'ms').format('MMM D')
    body = (
      _react2.default.createElement(StateScreen, { tone: "neutral", icon: _react2.default.createElement(ClockIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 171}} ), title: "This form has expired"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
        ,  view.FormName , " was open until "    ,  until , ". Ask "  ,  team , " to send it again."
      )
    )
  } else if ((_nullishCoalesce(view.Fields, () => ( []))).some(f => f.type === 'rows')) {
    body = _react2.default.createElement(_MonthLog2.default, { view: view, onRowAdded: onRowAdded, onViewPage: viewPage, onSigned: onSigned, __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}} )
  } else {
    body = _react2.default.createElement(_Signer2.default, { view: view, onSigned: onSigned, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}} )
  }

  return (
    _react2.default.createElement(_PatientPage.PatientPage, { caption: caption, prompt: NO_PROMPT, className: "form-fill", __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
      ,  body 
      ,  viewingPage && view && load === 'ready' && _react2.default.createElement(_PageView2.default, { view: view, onClose: closePage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}} ) 
    )
  )
}

exports. default = FormFill
